/**
 * Browser-side events of the "Tu primera semana" chip (Centro de Retos).
 *
 * Only the gestures the web app sees live here; mission state transitions
 * (practiced, completed) are emitted by workspace-service. Names follow
 * `front.<domain>.<entity>.<action>`, and every event carries `holdout_arm`.
 */
export const FIRST_WEEK_EVENTS = {
  /** The chip was painted in the navbar, once per workspace per browser tab. */
  CHIP_VIEWED: 'front.first_week.chip.viewed',

  /** The chip opened the mission panel. */
  PANEL_OPENED: 'front.first_week.panel.opened',

  /** A guided tour showed its first coachmark, once per run. */
  TOUR_STARTED: 'front.first_week.tour.started',

  /**
   * The person closed a guided tour (Saltar or Escape), on any step including
   * the last. Carries the id of the step they left from.
   */
  TOUR_ABANDONED: 'front.first_week.tour.abandoned',

  /** The "Misión cumplida" toast was raised for a completed mission. */
  TOAST_VIEWED: 'front.first_week.toast.viewed',
} as const;
